import React from 'react';

/** A speech bubble: the note field's leading icon in the booking modal. */
export function MessageIcon({
  className = 'h-5 w-5',
}: {
  className?: string;
}): React.ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.5}
      aria-hidden="true"
    >
      <path strokeLinejoin="round" d="M4 5.5h16v10H9l-5 4v-14z" />
    </svg>
  );
}
